import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellOptionsHeader = (props: UpsellOptionsHeaderProps) => {
  const { size, children } = props;

  const headerStyle =
    size === 'lg'
      ? [styles.container, styles.lowerContainer]
      : styles.container;

  return <View style={headerStyle}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingTop: theme.spacing['4'],
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  lowerContainer: {
    paddingTop: theme.spacing['10'],
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type UpsellOptionsHeaderProps = PropsWithChildren<{
  size: 'md' | 'lg';
}>;
